import React from 'react';

const VARIANTS = {
  CRITICO: { className: 'critical', label: 'Crítico' },
  BAJO: { className: 'review', label: 'Bajo' },
  SOBRESTOCK: { className: 'review', label: 'Sobrestock' },
  NORMAL: { className: 'ok', label: 'Normal' },
  URGENTE: { className: 'critical', label: 'Urgente' },
  SUGERIDO: { className: 'info', label: 'Sugerido' },
  NO_PEDIR: { className: 'ok', label: 'No pedir' },
  alta: { className: 'ok', label: 'Alta' },
  media: { className: 'review', label: 'Media' },
  baja: { className: 'critical', label: 'Baja' },
  pending: { className: 'review', label: 'Pendiente' },
  approved: { className: 'ok', label: 'Aprobado' },
  rejected: { className: 'critical', label: 'Rechazado' },
};

export default function StatusBadge({ status, label }) {
  const variant = VARIANTS[status] || { className: 'info', label: status };
  return (
    <span className={`status-badge ${variant.className}`} data-testid="status-badge">
      <span className="dot" />
      {label || variant.label}
    </span>
  );
}
